module.exports = __webpack_public_path__ + "static/media/bg_commond430124241c666eb0420e709cc6d7a50.webp";